import { render, staticRenderFns } from "./assetsCom.vue?vue&type=template&id=6c8af4d9"
import script from "./assetsCom.vue?vue&type=script&lang=js"
export * from "./assetsCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports